/* Canapuff B2B – B2C-style mega menu (desktop hover panels + mobile drawer level 2). Based on canapuff.com mm15.js */
(function () {
  'use strict';
  var DESK = window.matchMedia('(min-width: 1024px)');

  function initDesktop(root) {
    if (!root || root.__cpmm) return;
    root.__cpmm = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cpmm-tab]'));
    var tOpen, tClose;
    function btn(li) { return li.querySelector('.cpmm-tab-b'); }
    function setTop() {
      var r = root.getBoundingClientRect();
      document.documentElement.style.setProperty('--cpmm-top', Math.max(0, Math.round(r.bottom)) + 'px');
    }
    function close(li) { li.classList.remove('is-open'); btn(li).setAttribute('aria-expanded', 'false'); }
    function closeAll() { tabs.forEach(close); }
    function open(li) {
      tabs.forEach(function (o) { if (o !== li) close(o); });
      setTop();
      li.classList.add('is-open');
      btn(li).setAttribute('aria-expanded', 'true');
    }
    tabs.forEach(function (li) {
      btn(li).addEventListener('click', function (e) {
        e.stopPropagation();
        li.classList.contains('is-open') ? close(li) : open(li);
      });
      li.addEventListener('mouseenter', function () {
        if (!DESK.matches) return;
        clearTimeout(tClose); clearTimeout(tOpen);
        var other = root.querySelector('.cpmm-tab.is-open');
        tOpen = setTimeout(function () { open(li); }, other ? 60 : 120);
      });
      li.addEventListener('mouseleave', function () {
        if (!DESK.matches) return;
        clearTimeout(tOpen);
        tClose = setTimeout(function () { close(li); }, 250);
      });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) close(li); });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-cpmm]')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var o = root.querySelector('.cpmm-tab.is-open');
        if (o) { close(o); btn(o).focus(); }
      }
    });
    window.addEventListener('scroll', function () { if (root.querySelector('.cpmm-tab.is-open')) setTop(); }, { passive: true });
    if (DESK.addEventListener) DESK.addEventListener('change', closeAll);
  }

  function scrollParent(el) {
    var p = el.parentElement;
    while (p && p !== document.body) {
      var s = getComputedStyle(p).overflowY;
      if ((s === 'auto' || s === 'scroll') && p.scrollHeight > p.clientHeight) return p;
      p = p.parentElement;
    }
    return null;
  }

  function initDrawer(root) {
    if (!root || root.__cpmm) return;
    root.__cpmm = true;
    var l1 = root.querySelector('[data-cpmm-l1]');
    var sc = null, l1Scroll = 0, opener = null;
    function panel(i) {
      var p = root.querySelector('[data-cpmm-panel="' + i + '"]');
      if (!p) {
        var tpl = root.querySelector('template[data-cpmm-l2="' + i + '"]');
        if (!tpl) return null;
        root.appendChild(document.importNode(tpl.content, true));
        p = root.querySelector('[data-cpmm-panel="' + i + '"]');
      }
      return p;
    }
    function back(focusOpener) {
      var o = root.querySelector('.cpmmd-l2.is-open');
      if (o) o.classList.remove('is-open');
      root.classList.remove('in-l2');
      root.style.minHeight = '';
      if (sc) sc.scrollTop = l1Scroll;
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        if (focusOpener !== false) opener.focus({ preventScroll: true });
      }
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cpmm-open]');
      if (b) {
        var p = panel(b.getAttribute('data-cpmm-open'));
        if (!p) return;
        sc = scrollParent(root);
        l1Scroll = sc ? sc.scrollTop : 0;
        opener = b;
        b.setAttribute('aria-expanded', 'true');
        p.classList.add('is-open');
        root.classList.add('in-l2');
        root.style.minHeight = p.scrollHeight + 'px';
        if (sc) sc.scrollTop = 0;
        var bk = p.querySelector('.cpmmd-bar [data-cpmm-back]');
        if (bk) bk.focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('[data-cpmm-back]')) back();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('in-l2')) { e.stopPropagation(); back(); }
    }, true);
  }

  function initSearch() {
    document.querySelectorAll('[data-cpmm-search]').forEach(function (b) {
      if (b.__cpmm) return;
      b.__cpmm = true;
      var header = b.closest('.site-header');
      if (!header) return;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var on = header.classList.toggle('cpmm-search-open');
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on) {
          var input = header.querySelector('.live-search input[type="search"], .live-search input[name="q"]');
          if (input) setTimeout(function () { input.focus(); }, 30);
        }
      });
      document.addEventListener('click', function (e) {
        if (!header.classList.contains('cpmm-search-open')) return;
        if (e.target.closest && (e.target.closest('.live-search') || e.target.closest('[data-cpmm-search]'))) return;
        header.classList.remove('cpmm-search-open');
        b.setAttribute('aria-expanded', 'false');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') header.classList.remove('cpmm-search-open');
      });
    });
  }

  // Desktop: give all mega panels the height of the tallest one (same look on every tab)
  function equalizePanels() {
    var panels = Array.prototype.slice.call(document.querySelectorAll('.cpmm .cpmm-panel'));
    if (!panels.length) return;
    var grids = panels.map(function (p) { return p.querySelector('.cpmm-pgrid'); });
    grids.forEach(function (g) { if (g) g.style.minHeight = ''; });
    if (window.innerWidth < 1024) return;
    var max = 0;
    panels.forEach(function (p, i) {
      var g = grids[i]; if (!g) return;
      var old = p.getAttribute('style');
      p.style.cssText = (old || '') + ';display:block!important;visibility:hidden!important;position:absolute!important;left:0;right:0;pointer-events:none';
      // only panels whose right column (products + banners) is the tallest part set the common height;
      // panels with a very long link list (e.g. Cartridges & Pods) may grow taller instead of stretching all others
      var c1 = g.querySelector('.cpmm-c1'), c3 = g.querySelector('.cpmm-c3');
      if (!c1 || !c3 || c3.offsetHeight >= c1.offsetHeight) max = Math.max(max, g.offsetHeight);
      if (old === null) p.removeAttribute('style'); else p.setAttribute('style', old);
    });
    if (max > 0) grids.forEach(function (g) { if (g) g.style.minHeight = max + 'px'; });
  }

  function init() {
    document.querySelectorAll('[data-cpmm]').forEach(initDesktop);
    document.querySelectorAll('[data-cpmm-drawer]').forEach(initDrawer);
    initSearch();
    equalizePanels();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', equalizePanels);
  var cpmmRz; window.addEventListener('resize', function () { clearTimeout(cpmmRz); cpmmRz = setTimeout(equalizePanels, 200); });
})();
